import { axiosClient, type IResponse } from '~/common/js/axios';
import type { AxiosRequestConfig } from 'axios';

/**
* 订单创建前置校验
*/
export function createCheck_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/order/createCheck',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}
// 鸽子王
export const CANCEL_PIGEON_CODE = 48238;

export interface create_POST_res_type {
  /** 订单ID */ 
  orderId: string 
}
/**
* 创建订单
*/
export function create_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<create_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/order/create',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getStatistic_GET_res_type {
  /** 进行中的订单统计 */ 
  processingOrderCount: number 
}
/**
* 获取订单统计
*/
export function getStatistic_get(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getStatistic_GET_res_type>>({
    url: '/gw-api/p2p-trade/p2p/order/getStatistic',
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    params: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 提醒卖家放币
* @property {Object} options.data 接口参数
* @property {text} options.data.orderId 订单ID
*/
export function remindRelease_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/order/remindRelease',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 取消订单
*/
export function cancel_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/order/cancel',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 修改订单状态,付款成功，放币
*/
export function updateStatus_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-trade/p2p/order/updateStatus',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface searchOrderList_POST_res_type {
  /** 分页信息 ,PageInfo */ 
  pageInfo: object 
  /** 订单列表 ,QueryOrderInfoResponse */ 
  items: Array<any> 
}
/**
* 搜索指定订单(分页)
*/
export function searchOrderList_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<searchOrderList_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/order/searchOrderList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getOrderLst_POST_res_type {
  /** 分页信息 ,PageInfo */ 
  pageInfo: object 
  /** 订单列表 ,QueryOrderInfoResponse */ 
  items: Array<any> 
}
/**
* 分页查询订单
*/
export function getOrderLst_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getOrderLst_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/order/getOrderLst',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getOrderDetail_POST_res_type {
  /** 订单id */ 
  orderId: number 
  /** 买卖类型筛选,buy,sell */ 
  side: string 
  /** 法币 */ 
  currency: string 
  /** 虚拟币 */ 
  crypto: string 
  /** 价格 */ 
  price: string 
  /** 虚拟币数量 */ 
  size: string 
  /** 法币金额 */ 
  amount: string 
  /** 支付方式背景色 */ 
  bgColor: string 
  /** 支付方式 */ 
  payType: string 
  /** 支付类型名称(i18n国际化)[用该字段展示支付方式] */ 
  payTypeDesc: string 
  /** 用户支付方式的相关必填和选填信息展示 ,PayFieldInfo */ 
  payFieldInfoList: Array<any> 
  /** 用户昵称,买家:看到的是卖家的昵称,卖家：看到的是买家的昵称 */ 
  userName: string 
  /** 订单状态:0进行中，1已取消，2已完成，3申诉中 */ 
  state: number 
  /** 二级状态    WAIT_PAY(0, "等待支付"),     WAIT_RELEASE(1, "等待放币"),     RELEASE_COMPLETE(2, "卖家已放币"),     BUYER_CANCEL(3, "买家取消"),     TIMEOUT_CANCEL(4, "支付超时取消") */ 
  stateLabel: number 
  /** 是否存在申诉记录：true:存在，false 不存在 */ 
  existDispute: boolean 
  /** 是否是自己发起的申诉，true表示自诉，false-非自诉，
当前字段仅针对 existDispute = true，才有意义 */ 
  selfDispute: boolean 
  /** 支付时间 */ 
  payTime: string 
  /** 放币时间(订单完成时间) */ 
  releaseTime: string 
  /** 创建时间 */ 
  createTime: string 
  /** 倒计时时间 */ 
  countdownTime: number 
  /** 订单超时剩余时间，单位秒 */ 
  leftTime: number 
  /** 取消原因 (枚举映射)
1 - I don’t want to buy anymore  
2 - I can’t contact the seller  
3 - I’m a new user, don’t know how to trade 
4 - Other reasons */ 
  cancelReason: string 
  /** 对手方cid */ 
  counterpartyCid: number 
  /** 提醒放币次数 */ 
  remindNum: number 
  /** 最新提醒放币时间戳 */ 
  lastRemindTime: string 
  /** boolean 是否允许提醒-控制提醒按钮 */ 
  allowRemind: boolean 
  /** true: 表示已拉黑对方，false 表示未拉黑 */ 
  blocked: boolean 
}
/**
* 查询单个订单
*/
export function getOrderDetail_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getOrderDetail_POST_res_type>>({
    url: '/gw-api/p2p-trade/p2p/order/V1/getOrderDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}
